module.exports = __webpack_public_path__ + "img/an-old-kitchen-counter-3257923.95c9f5d9.jpg";